<template>
<el-container class="bg-gray">
      <el-main class="container">
        <div class="form-box">
          <div class="row">
            <div class="title">内容</div>
            <el-input type="textarea" class="input-width textarea" v-model="body.content" placeholder="请输入内容"/>
          </div>
          <div class="row">
            <div class="title">关联产业</div>
            <el-select v-model="selectIndustry" clearable class="input-width" placeholder="请选择产业">
              <el-option
                v-for="item in industryList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>

          <div class="row">
            <div class="title">详情</div>
            <wang-editor
              ref="editor"
              @editorContent="getEditorContent"/>
          </div>

          <div class="f-row">
            <el-date-picker
              value-format="yyyy-MM-dd HH:mm:ss"
              class="date-picker"
              v-model="dateVal"
              type="datetime"
              placeholder="选择日期时间"
              >
            </el-date-picker>
          </div>

          <div class="btn-box">
            <el-button @click="handleReturn">取消</el-button>
            <el-button type="primary" @click="handleSubmit">确认</el-button>
          </div>
        </div>
      </el-main>
</el-container>
</template>

<script>
import { getIndustrySelectList } from '@/api/industry'
import { addConsult, updateConsult, getConsultDetail } from '@/api/basic'
import { formatTime } from '@/jslib/utils'
import WangEditor from '@/components/Wangeditor/index'
export default {
  components: {
    WangEditor
  },
  data() {
    return {
      body: {
        content: '',
        industryUuid: '',
        startTime: '',
        uuid: '',
        details: '',
      },
      industryList: [],
      selectIndustry: '',
      dateVal: '',
      pageType: 'add',
    }
  },
  created() {
    this.network().getIndustrySelectList()
  },
  mounted() {
    if (this.$route.query.id) {
      let id = this.$route.query.id
      this.body.uuid = id
      this.pageType = 'set'
      this.network().getConsultDetail(id)
      // const data = JSON.parse(this.$route.query.info)
      // this.body.uuid = data.uuid
      // this.body.content = data.content
      // this.body.startTime = data.startTime
      // this.dateVal = data.startTime
      // this.selectIndustry = data.industryUuid
      // this.$nextTick(()=>{
      //   this.$refs.editor.setHtml(data.details)
      // })
    } else {
      this.dateVal = formatTime(new Date())
    }
  },
  methods: {
    network() {
      return {
        getIndustrySelectList: async() => {
          const { data } = await getIndustrySelectList()
          data.forEach(item => {
            this.industryList.push({
              value: item.uuid,
              label: item.name
            })
          })
        },
        addConsult: async() => {
          await addConsult(this.body)
          this.$message({
            type: 'success',
            message: '添加成功'
          })
          this.$router.push('/basic-management/consult-list')
        },
        updateConsult: async() => {
          await updateConsult(this.body)
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.$router.push('/basic-management/consult-list')
        },
        getConsultDetail: async (uuid) => {
          let { data } = await getConsultDetail(uuid)
          this.body.content = data.content
          this.body.startTime = data.startTime
          this.dateVal = data.startTime
          this.selectIndustry = data.industryUuid
          this.$refs.editor.setHtml(data.details)
        }
      }
    },
    getEditorContent(data) {
      this.body.details = data
    },
    handleReturn() {
      this.$router.go(-1)
    },
    checkboxChange(isCheck){
      if(isCheck){
        this.disDatePicker = false
      } else {
        this.dateVal = ''
        this.disDatePicker = true
        this.dateVal = formatTime(new Date())
      }
    },
    checkForm() {
      if (this.body.content === '') {
        this.$message.error('请输入内容')
        return false
      } else if (this.body.industryUuid === '') {
        this.$message.error('请选择关联产业')
        return false
      } else if (this.body.startTime === '') {
        this.$message.error('请选择定时发布时间')
        return false
      }
      return true
    },
    handleSubmit() {
      if (this.dateVal === null) {
        this.dateVal = ''
      } else if (this.body.content === undefined) {
        this.body.content = ''
      } else if (this.selectIndustry === undefined) {
        this.selectIndustry = ''
      }
      this.body.industryUuid = this.selectIndustry
      this.body.startTime = this.dateVal
      if (this.checkForm()) {
        this.pageType === 'add' ? this.network().addConsult() : this.network().updateConsult()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.form-box{
  .row{
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    .title{
      line-height: 50px;
    }
    .input-width{
      width: 500px;
    }
    /deep/.el-textarea__inner{
      height: 200px;
    }
  }
  .f-row{
    margin-top: 60px;
    display: flex;
    .radio{
      display: flex;
      align-items: center;
      margin-right: 30px;
    }
    .date-picker{
      display: flex;
      align-items: center;
    }
  }
  .btn-box{
    margin-top: 300px;
    display: flex;
    justify-content: center;
    button{
      height: 50px;
      width: 150px;
    }
  }

  .editor{
    width: 60%;
  }
}
</style>
